import { Component, Input } from '@angular/core';
import { CandidatStatusOnMission, FlagType } from '../utils/enums';
import { Router } from '@angular/router';
import { MissionService } from '../../services/mission.service';
import { AuthService } from '../../services/auth.service';
import { FlagService } from '../services/flag.service';
import { MatDialog } from '@angular/material/dialog';
import { DetailRefuComponent } from '../../pages/candidat/detail-refu/detail-refu.component';
import { FormAnnulationContractComponent } from '../../pages/candidat/form-annulation-contract/form-annulation-contract.component';
import { CandidatMissionStatusPipe } from '../pipes/candidat-mission-status.pipe';
import { ActualWorkingHoursComponent } from '../../pages/candidat/components/actual-working-hours/actual-working-hours.component';

@Component({
  selector: 'app-status-candidat-mission',
  templateUrl: './status-candidat-mission.component.html',
  styleUrl: './status-candidat-mission.component.scss',
})
export class StatusCandidatMissionComponent {
  @Input() data: any;
  @Input() column: any;
  statusOfCandidatOnMission = CandidatStatusOnMission;
  statusText: any;
  constructor(
    private router: Router,
    private missionApi: MissionService,
    private auth: AuthService,
    private flag: FlagService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
  }
  goTo(id: number) {
    this.router.navigate(['missinDetails', id]);
  }

  openImputationDialog(mission:any){
    console.log(mission);
    
    const dialogRef = this.dialog.open(ActualWorkingHoursComponent, {
      width: '800px',
      data: {
        missionId: mission.id,
        startDate: mission.startdate,
        endDate: mission.enddate,
        establishmentName: mission.etablissementNom,
        serviceName: mission.serviceAffectationsName,
        missionReference: mission.missionTitle,
        workingHours: mission.workingHours
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh mission data or show success message
        console.log('Working hours were saved successfully');
      }
    });
  }

  deleteMission(id: number) {
    this.missionApi
      .SupprissionMission({
        candidatId: Number(this.auth.user?.collary_id),
        missionId: id,
        status: 'ARCHIVED',
      })
      .subscribe({
        next: (data: any) => {
          this.flag.displayFlag(
            'La mission a été supprimée avec succès !',
            FlagType.success
          );
        },
        error: (err) => console.log(err),
      });
  }
  voirDetails(data: any) {
    this.dialog.open(DetailRefuComponent, {
      backdropClass: 'bg-transparent',
      width: '400px',
      data,
      // animation: { to: "left" }
    });
  }
  sendMail(data: any) {
    this.dialog.open(FormAnnulationContractComponent, {
      backdropClass: 'bg-transparent',
      data: {
        data,
        textFormulaire: `Contester le refus de validation de ma mission N° ${data.id}`,
      },
    });
  }
}
